import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import Seo from '../components/Seo';
import { useT } from '../i18n/LangContext';

export default function NotFound() {
  const t = useT();

  return (
    <section data-testid="not-found" className="bg-ink py-40 text-center">
      <Seo title={t['seo.notfound.title']} description={t['seo.notfound.desc']} />
      <p className="font-serif text-7xl font-semibold text-gold/30">404</p>
      <h1 className="mt-4 font-serif text-3xl font-semibold">{t['nf.h1']}</h1>
      <p className="mt-3 text-sm text-silver">{t['nf.p']}</p>
      <Link data-testid="not-found-cta" to="/quote" className="gold-btn mt-8">{t['nf.cta']} <ArrowRight className="h-4 w-4" /></Link>
    </section>
  );
}
